import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const ActivityFeedPage = lazy(async () => {
  const m = await import("@/features/activity/components/activity-feed-page");
  return { default: m.ActivityFeedPage };
});

/**
 * ACTIVITY-CORE (L3) — "who did what" feed of the account and its organizations,
 * with integrity verification (hash-chain) and trail export (compliance).
 */
export const activityRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/activity",
  component: () => (
    <Suspense fallback={null}>
      <ActivityFeedPage />
    </Suspense>
  ),
});
